<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class="ri-focus-3-line me-1 text-primary"></i>OKR
                </h5>
              </div>
              <div class="col-sm-12 col-md-5 col-lg-3 me-auto">
                <div class="input-group">
                  <span class="input-group-text bg-primary" id="search" ngbTooltip="Search appraisal by label."
                    placement="top" container="body">
                    <i class="bx bx-search-alt"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" id="search" placeholder="Search..."
                    autocomplete="off" [(ngModel)]="searchKeyword">
                </div>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="70">#</th>
                  <th scope="col" width="300">Label</th>
                  <th scope="col" width="200">Start Year</th>
                  <th scope="col" width="250">End Year</th>
                  <th scope="col" width="300">Start Quarter</th>
                  <th scope="col" width="300">End Quarter</th>
                  <th scope="col" width="300">Status</th>
                  <th scope="col" width="200" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let appraisal of appraisals | search : 'label' : searchKeyword; let i=index">
                  <td>{{i+1}}.</td>
                  <td>{{appraisal.label}}</td>
                  <td>{{appraisal.year}}</td>
                  <td>{{appraisal.endYear}}</td>
                  <td>{{appraisal.startName}}</td>
                  <td>{{appraisal.endName}}</td>  
                  <td>{{appraisal.status}}</td>
                  <td class="actions">
                    <button type="button" class="btn approve-btn btn-sm" [ngClass]="{'no-event':appraisal?.inProgress,'not-allowed':!privilege.canEdit, 'btn-outline-info': !appraisal?.active, 
                      'btn-outline-success': appraisal?.active }"
                      [ngbTooltip]="privilege.canEdit ? (appraisal?.active ? 'Add Objectives' : 'View Objectives') 
                      : 'You need permissions for this action. Required permission(s): setup.appraisal.edit'"
                      (click)="upsertOkr(appraisal)">
                      <ng-container *ngIf="inProgress?.value!='true'">
                        <i class="bx" [ngClass]="appraisal?.active ? 'bx-check' : 'bx-show'"></i>
                        {{ appraisal?.active ? 'Objectives' : 'View' }}
                      </ng-container>
                    </button>
                  </td>
                </tr>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="8">Fetching data, please wait...</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-template #noSearchResults>
                      <td colspan="8"
                        *ngIf="searchKeyword && (appraisals | search : 'name' : searchKeyword).length == 0">
                        No Appraisals were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>